import { Type } from '@angular/core';
import { Route, Routes } from '@angular/router';

import assert from 'tiny-invariant';

// Route `data` key carrying the page a wrapped route renders inside the shell.
export const IONIC_PAGE_SHELL_COMPONENT_CLASS_KEY =
  'ionicPageShellComponentClass';

// Since this is used inside routing, cannot be put inside service.
export function wrapRoutesInIonicPageShell(
  routes: Routes,
  wrapperClass: Type<unknown>,
): Routes {
  const wrappedRoutes: Routes = [];

  for (const route of routes) {
    const wrappedRoute: Route = { ...route };
    // Recursive call if has a children list.
    if (route.children) {
      wrappedRoute.children = wrapRoutesInIonicPageShell(
        route.children,
        wrapperClass,
      );
    } else if (route.component) {
      // We do not want to override the component if it has children.
      const componentClass = route.component;
      wrappedRoute.component = wrapperClass;

      // Pass the component through data parameter to be read by IonicPageShell
      if (!wrappedRoute.data) {
        wrappedRoute.data = {};
      }
      assert(!(IONIC_PAGE_SHELL_COMPONENT_CLASS_KEY in wrappedRoute.data));
      wrappedRoute.data[IONIC_PAGE_SHELL_COMPONENT_CLASS_KEY] = componentClass;
    }

    wrappedRoutes.push(wrappedRoute);
  }

  return wrappedRoutes;
}
